import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BlockErrors, CheckboxItem, InputGroupBase } from '@/components';
import { useResolveValue } from '@/hooks';
import { filterBlockAnswers, getAnswerValue, getInputBlockAnswer } from '@/utils';
import { BlockLayout } from '../fragments/BlockLayout';
export const Radio = ({ block: { answer_filters = [], id, images, key, layout, typed_answers }, defaultValue, errors = [], onChange }) => {
    const selectedValue = useMemo(() => {
        return getAnswerValue(defaultValue);
    }, [defaultValue]);
    const [resolver] = useResolveValue();
    const resolved = useMemo(() => {
        const answerKeys = resolver.resolveAnswerFilter(answer_filters);
        const filters = filterBlockAnswers(typed_answers.answers, answerKeys, defaultValue);
        const answersList = filters.answersFiltered.map((a, order) => {
            return Object.assign(Object.assign({}, a), { label: resolver.resolveString(a.label), order });
        });
        return {
            answersList
        };
    }, []);
    const handleChange = (answer) => {
        const newAnswer = getInputBlockAnswer(typed_answers.type, answer, key);
        onChange(newAnswer, { order: answer.order });
    };
    return (_jsx(BlockErrors, Object.assign({ errors: errors }, { children: _jsx(BlockLayout, Object.assign({ layout: layout }, { children: _jsx(InputGroupBase, Object.assign({ "data-test": id }, { children: resolved.answersList.map((item) => {
                    const value = JSON.stringify(item.value);
                    const isChecked = selectedValue !== undefined &&
                        selectedValue !== null &&
                        value === JSON.stringify(selectedValue);
                    return (_jsx(CheckboxItem, { answer: item, answerChange: handleChange, images: images, isChecked: isChecked }, item.id));
                }) })) })) })));
};
